import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { marketingProblems } from "../../data/mock";
import { Button } from "../ui/button";
import { ChevronRight, AlertCircle, Eye, Target, Users, TrendingUp, MessageSquare, Heart } from "lucide-react";

const problemIcons = [
  Eye,
  AlertCircle,
  Target,
  Users,
  TrendingUp,
  MessageSquare,
];

const Problems = () => {
  const [activeIndex, setActiveIndex] = useState(0);
  const navigate = useNavigate();

  return (
    <section className="py-24 px-4 bg-slate-950">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-16">
          <span className="text-emerald-400 text-sm font-semibold tracking-wider uppercase">
            Sound Familiar?
          </span>
          <h2 className="text-3xl md:text-4xl font-bold text-white mt-4 mb-4">
            Local Business Challenges, Solved
          </h2>
        </div>

        <div className="grid lg:grid-cols-2 gap-12">
          {/* Problems List */}
          <div className="space-y-3">
            {marketingProblems.map((item, index) => {
              const IconComponent = problemIcons[index];
              return (
                <button
                  key={index}
                  onClick={() => setActiveIndex(index)}
                  className={`w-full text-left p-4 rounded-xl transition-all duration-300 flex items-center gap-4 ${
                    activeIndex === index
                      ? "bg-emerald-500/10 border-2 border-emerald-500/50"
                      : "bg-slate-900/50 border-2 border-slate-800 hover:border-slate-700"
                  }`}
                >
                  <div
                    className={`w-10 h-10 rounded-lg flex items-center justify-center flex-shrink-0 ${
                      activeIndex === index
                        ? "bg-emerald-500/20 text-emerald-400"
                        : "bg-slate-800 text-slate-500"
                    }`}
                  >
                    <IconComponent className="w-5 h-5" />
                  </div>
                  <span
                    className={`font-medium ${
                      activeIndex === index ? "text-emerald-400" : "text-slate-300"
                    }`}
                  >
                    {item.problem}
                  </span>
                  <ChevronRight
                    className={`w-5 h-5 ml-auto transition-transform ${
                      activeIndex === index
                        ? "text-emerald-400 rotate-90"
                        : "text-slate-600"
                    }`}
                  />
                </button>
              );
            })}
          </div>

          {/* Solution Display */}
          <div className="bg-gradient-to-br from-slate-900 to-slate-800 border border-slate-700 rounded-3xl p-8 md:p-12 flex flex-col justify-center">
            <div className="bg-slate-800/50 rounded-2xl p-6 border border-slate-700">
              <h3 className="text-xl font-semibold text-white mb-4">
                {marketingProblems[activeIndex].problem}
              </h3>
              <p className="text-slate-400 leading-relaxed mb-6">
                {marketingProblems[activeIndex].solution}
              </p>
              <Button 
                onClick={() => navigate("/create")}
                className="bg-emerald-500 hover:bg-emerald-600 text-white rounded-full"
              >
                Solve This Now
              </Button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Problems;
